module.exports = __webpack_public_path__ + "static/media/new-map-without-buttons.e33fd78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/new-map-without-buttons.png
// module id = 1062
// module chunks = 0